import { render, staticRenderFns } from "./ProveedoresModal.vue?vue&type=template&id=90877af0&"
import script from "./ProveedoresModal.vue?vue&type=script&lang=js&"
export * from "./ProveedoresModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports